import { useEffect, useRef } from 'react'
import useRemoteParticipants from './useRemoteParticipants'
import { playAudio } from '@/utils/audioPlayback'

const participantJoinedSound = 'https://assets.myjobglasses.com/immersion/phone-calls/participant-joined.mp3'

/**
 * Hook to play a notification sound when a participant joins the meeting
 * Only plays when a new participant joins (not on initial page load)
 */
export const useParticipantJoinNotification = (speakerDeviceId?: string) => {
  const { activeRemoteAttendees } = useRemoteParticipants()
  const previousCountRef = useRef<number | null>(null)

  useEffect(() => {
    const currentCount = activeRemoteAttendees.length

    // On first render, just store the count without playing sound
    if (previousCountRef.current === null) {
      previousCountRef.current = currentCount
      return
    }

    // If participant count increased, someone joined
    if (currentCount > previousCountRef.current && currentCount > 0) {
      // Play the notification sound
      playAudio({
        audioFile: participantJoinedSound,
        speakerDeviceId,
        volume: 0.5
      })
        .catch((error) => {
          // Silently fail if autoplay is blocked by browser
          console.debug('Could not play participant join sound:', error)
        })
    }

    // Update the previous count
    previousCountRef.current = currentCount
  }, [activeRemoteAttendees.length, speakerDeviceId])
}
